import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DashboardStats } from '../../services/dashboardApi';

interface DashboardState {
  stats: DashboardStats;
  loading: boolean;
  error: string | null;
}

const initialState: DashboardState = {
  stats: {
    totalParts: 0,
    totalPurchaseOrders: 0,
    totalWorkOrders: 0,
    activeWorkOrders: 0,
    completedWorkOrders: 0,
    totalUsers: 0,
    totalClients: 0,
    recentActivity: [],
  },
  loading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    fetchDashboardStatsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchDashboardStatsSuccess: (state, action: PayloadAction<DashboardStats>) => {
      state.stats = action.payload;
      state.loading = false;
    },
    fetchDashboardStatsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  fetchDashboardStatsStart,
  fetchDashboardStatsSuccess,
  fetchDashboardStatsFailure,
  clearError,
} = dashboardSlice.actions;

export default dashboardSlice.reducer; 